import React from "react";
import SignImg from "../image/guidstamp.png";

export default function NonDisclousre({inspectorDetails}) {
  return (
    <div className="py-6 text-justify font-sans text-sm leading-relaxed text-gray-800 space-y-4 px-10 mx-5">
      <p>
        This Agreement is between AIPL and {inspectorDetails?.inspectorName || "_____"} an
        individual (“EMPLOYEE”) working at DYC Global Inspections Private
        Limited. WHEREAS, AIPL has developed through substantial effort,
        research, time, and expense certain inventions, design concepts,
        methodologies, technical know-how, copyrightable material and trade
        secrets directed and related
        to
        (“INFORMATION”);
      </p>

      <p>
        WHEREAS, AIPL desires to disclose the INFORMATION on a confidential
        basis to EMPLOYEE solely for the purposes of evaluating the INFORMATION
        for possible future business arrangements; and WHEREAS, AIPL wishes to
        maintain the confidentiality of the INFORMATION and the protection of
        AIPL'S intellectual property rights. NOW, THEREFORE, in consideration of
        the mutual promises, covenants, and conditions contained herein, the
        sufficiency of which is hereby acknowledged, the parties agree as
        follows:
      </p>

      <h2 className="font-bold">I. CONFIDENTIAL INFORMATION</h2>
      <ol className="list-inside ml-4 space-y-2" type="A">
        <li style={{ listStyle: "upper-alpha" }}>
          AIPL agrees to disclose INFORMATION to EMPLOYEE to facilitate possible
          future business dealings between the parties.
        </li>
        <li style={{ listStyle: "upper-alpha" }}>
          EMPLOYEE agrees to receive such INFORMATION and to refrain from
          copying, disclosing, using, selling, or offering for sale any and all
          of said INFORMATION, other than at the request of AIPL, with the
          exceptions as provided in paragraph C herein. EMPLOYEE agrees to keep
          confidential and refrain from disclosing any and all of the
          INFORMATION, and to take all necessary and reasonable steps to prevent
          unauthorized disclosure or use of any and all of the INFORMATION.
        </li>
        <li style={{ listStyle: "upper-alpha" }}>
          Notwithstanding paragraph B, EMPLOYEE shall not be liable for
          disclosure or use of INFORMATION only if, and only to the extent that,
          said INFORMATION was in the public domain at the time it was disclosed
          by AIPL, or was known to and recorded in writing by EMPLOYEE prior to
          the time of disclosure by AIPL, or is received from a third party or
          passes into the public domain without breach of this Agreement. With
          respect to any INFORMATION known by EMPLOYEE prior to the time of
          disclosure by AIPL that EMPLOYEE believes to constitute the
          INFORMATION, or any portion thereof, EMPLOYEE shall disclose to AIPL
          an adequate written description of the INFORMATION within fourteen
          (14) days of the disclosure by AIPL.
        </li>
        <li style={{ listStyle: "upper-alpha" }}>
          This is not an offer for sale or license. No right or license is
          granted by AIPL to EMPLOYEE in connection with the technical
          information or inventions disclosed under this agreement. All
          documents or materials constituting the INFORMATION and all
          reproductions thereof shall at all times remain the sole property of
          AIPL and shall promptly be returned by EMPLOYEE upon request.
        </li>
        <li style={{ listStyle: "upper-alpha" }}>
          This Agreement shall remain in force in spite of disclosure of the
          INFORMATION by AIPL in the form of patent applications, copyright
          applications, or other disclosures by AIPL.
        </li>
      </ol>

      <h2 className="font-bold">II. RESTRICTIONS</h2>
      <ol
        className="list-inside ml-4 space-y-2"
        style={{ listStyle: "upper-alpha" }}
      >
        <li>
          Except for the express written consent of AIPL, EMPLOYEE agrees:
          <ul className="list-decimal list-inside ml-4">
            <li style={{ listStyle: "decimal" }}>
              Not to use or disclose to another person or entity any
              confidential information of AIPL;
            </li>
            <li style={{ listStyle: "decimal" }}>
              Not to make, or cause to be made, any copies, facsimiles or other
              reproductions including data files of any documents containing
              confidential information of AIPL;
            </li>
            <li style={{ listStyle: "decimal" }}>
              To use all other reasonable means to maintain the secrecy and
              confidentiality of the confidential information of AIPL.
            </li>
          </ul>
        </li>
        <li>
          EMPLOYEE further agrees, at the request of AIPL:
          <ul className="list-decimal list-inside ml-4">
            <li style={{ listStyle: "decimal" }}>
              To immediately return to AIPL all of the items in the possession
              of EMPLOYEE which relate to or which disclose in whole or in part
              any confidential information of AIPL;
            </li>
            <li style={{ listStyle: "decimal" }}>
              To refrain from using or disclosing to any other person or entity
              any confidential information of AIPL.
            </li>
          </ul>
        </li>
      </ol>

      <h2 className="font-bold">III. INTELLECTUAL PROPERTY</h2>
      <p>
        <strong>A. Title and Copyright Assignment</strong>
      </p>
      <ul className="list-decimal list-inside ml-8">
        <li style={{ listStyle: "decimal" }}>
          All products and results of EMPLOYEE’S services rendered hereunder
          (the "Work") are works made for hire. EMPLOYEE acknowledges and agree
          that the Work (and all rights therein, including, without limitation,
          copyrights) belongs to and shall be the sole and exclusive property of
          AIPL.{" "}
        </li>
        <li style={{ listStyle: "decimal" }}>
          Notwithstanding the foregoing, EMPLOYEE also hereby assigns and
          transfers to AIPL, its successors and assigns, the entire right,
          title, and interest in and to all copyrights in the Work; all
          registrations and copyright applications relating thereto and all
          renewals and extensions thereof; all works based upon, derived from,
          or incorporating the Work; all income, royalties, damages, claims and
          payments now or hereafter due or payable with respect thereto; all
          causes of action, either in law or in equity for past, present, or
          future infringement based on the copyrights; and all rights
          corresponding to the foregoing throughout the world.
        </li>
        <li style={{ listStyle: "decimal" }}>
          If the Work is one to which the provisions of Indian Contract Act
          apply, EMPLOYEE hereby waives and appoints AIPL to assert on
          EMPLOYEE’S behalf EMPLOYEE’S moral rights or any equivalent rights
          regarding the form or extent of any alteration to the Work (including,
          without limitation, removal or destruction) or the making of any
          derivative works based on the Work, including, without limitation,
          photographs, drawings or other visual reproductions or the Work, in
          any medium, for AIPL'S purposes.
        </li>
        <li style={{ listStyle: "decimal" }}>
          EMPLOYEE agrees to execute all papers and to perform such other proper
          acts as AIPL may deem necessary to secure for AIPL or its designee the
          rights herein assigned.
        </li>
      </ul>

      <p>
        <strong>B. Patent Assignment</strong>
      </p>

      <ul className="list-decimal list-inside ml-8">
        <li style={{ listStyle: "decimal" }}>
          EMPLOYEE may invent new, original, and ornamental or useful inventions
          in the course of or related to EMPLOYEE’S business relationship with
          AIPL ("the Inventions").
        </li>
        <li style={{ listStyle: "decimal" }}>
          EMPLOYEE hereby assigns and/or transfers to AIPL, its successors or
          assigns, the entire right, title, and interest in and to said
          Inventions, and any patent and patent applications deriving there from
          for any such invention in the India and throughout the world,
          including the right to file foreign applications directly in the name
          of AIPL and to claim for any such foreign applications any priority
          rights to which such applications are entitled under international
          conventions, treaties, or otherwise; and to cooperate with AIPL as may
          be necessary or desirable for obtaining, sustaining, reissuing, or
          enforcing said patent or patent applications in the India and
          throughout the world for said Inventions, and for perfecting,
          recording, or maintaining any such title in AIPL
        </li>
        <li style={{ listStyle: "decimal" }}>
          Notwithstanding the above, EMPLOYEE shall not assign and/or transfer
          any invention for which no confidential information of AIPL was used,
          unless the invention results from any work performed by EMPLOYEE for
          AIPL. C. AIPLship of Trademarks EMPLOYEE hereby acknowledges that AIPL
          shall retain all right, title, and interest in all trademarks, trade
          dress, and good will that results from the INFORMATION or any use or
          offer to sell thereof.
        </li>
      </ul>

      <p>
        <strong>C. Ownership of Trademarks</strong>
      </p>
      <p>
        EMPLOYEE hereby acknowledges that AIPL shall retain all right, title,
        and interest in alltrademarks, trade dress, and good will that results
        from the INFORMATION or any use or offer to sellthereof.
      </p>

      {/* <div className="mt-6">
        <div className="flex justify-between mt-4">
          <div>
            <p className="font-semibold">AIPL</p>
            <img src={SignImg} />
            <br />
            <p className="text-sm">(Signature)</p>
          </div>
          <div>
            <p className="font-semibold">EMPLOYEE</p>
            <br />
            <br />
            <br />
            <p className="text-sm">(Signature)</p>
          </div>
        </div>

        <div className="flex justify-between mt-4">
          <div>
            <p className="text-sm">Date</p>
            <p className="border-t border-gray-400 w-48" />
          </div>
          <div>
            <p className="text-sm">Date</p>
            <p className="border-t border-gray-400 w-48" />
          </div>
        </div>
      </div> */}
       <div className="grid grid-cols-2 text-center mt-10 pt-10 font-medium">
        {/* Left Side */}
        <div className="flex flex-col items-center">
          <span>AIPL</span>
          <span>Ramesh S Jadhav</span>
          <div className="mt-10">
            <img
              src={SignImg}
              alt="AIPL Signature"
              className="mx-auto h-14"
            />
          </div>
          <div className="mt-2">{inspectorDetails?.policyDate || "_____"}</div>
        </div>

        {/* Right Side */}
        <div className="flex flex-col items-center">
          <span>EMPLOYEE</span>
          <span>{inspectorDetails?.inspectorName || "_____"}</span>
          <div className="mt-10">
            {inspectorDetails?.userSign ? (
              <img
                src={inspectorDetails.userSign}
                alt="Inspector Signature"
                className="mx-auto h-12"
              />
            ) : (
              "(Signature)"
            )}
          </div>
          <div className="mt-2">{inspectorDetails?.policyDate || "_____"}</div>
        </div>
      </div>
    </div>
  );
}
